import { Button, DatePicker, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import isEqual from "react-fast-compare";
import {
  setBrandsInScreen,
  setCampaignProfileList,
  setCampaignQuickProfile,
  setClearAllScreenWidgetGraphData,
  setDurationInScreen,
  setMarkInfluencersFlag,
  setOpenCampaignPopup,
  setProfileListInScreen,
  setScreenCampaignDate,
  setScreenDeepDiveData,
  setScreenRefreshEvent,
  setSelectedProfileInScreen,
} from "../../../redux/actions/commandCenter/screens/screen";
import { useDispatch, useSelector } from "react-redux";
import BrandsLogicalGroup from "../../layout/WelcomePage/Template/BrandsLogicalGroup";
import ProfileSelection from "../../layout/WelcomePage/Template/ProfileSelection";
import {
  setChannelImage,
  setProfileImage,
  setSelectProfileId,
} from "../../../redux/actions/Template";
import moment from "moment";
import durationIcon from "../../../assets/calendarIconLB.svg";
import durationWhiteIcon from "../../../assets/WhiteIcons/calendarWhiteIconLB.svg";
import {
  getBrands,
  getDefaultDuration,
  rangePickerDisabledDate,
} from "../../../redux/constants";
import { setGraphPageLogicalBrandValue } from "../../../redux/actions/LogicalGroup";
import {
  InsertMarkInfluencerPost,
  deletePostFromTool,
  removeMarkInfluencerPost,
} from "../../../redux/actions/commandCenter/commandCenterApi";
import { getDeepDive } from "../../../redux/actions/WidgetMaker/WidgetAPI";
import {
  setDeepDiveInfoLoader,
  setMentionPageInnerTabs,
} from "../../../redux/actions/DeepDive";
const { Option } = Select;

const MarkInfluencerPost = ({ isOpen, setMarkInfluencer, markInfluencer }) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const screen = useSelector((state) => state?.Screens?.screen);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const markInfluencerList = screen?.markInfluencersList;
  const mentions_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_mentions_object
  );
  const influencers_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_influencers_object
  );
  const tabClick = useSelector((state) => state.DeepDive.tabClick);
  const enumConfig = useSelector((state) => state.apiCall.enumConfig);
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );

  const [selectedInfluencer, setSelectedInfluencer] = useState({
    category: "",
    categoryID: "",
  });

  // Determine if multiple selection is allowed based on frontend_type
  const isMultipleSelect =
    workspace_privileges?.environment === 2 ? true : false;
  const [selectedInfluencers, setSelectedInfluencers] = useState([]);

  useEffect(() => {
    if (isMultipleSelect) {
      // For multiple select, initialize with array
      if (
        markInfluencer?.data?.InfluencerCategories &&
        Array.isArray(markInfluencer?.data?.InfluencerCategories)
      ) {
        // If data has InfluencerCategories array
        const selectedCategories =
          markInfluencer?.data?.InfluencerCategories.map(
            (cat) => cat?.influencerCategoryName
          );
        setSelectedInfluencers(selectedCategories || []);
      } else if (markInfluencer?.data?.InfluencerCategoryID) {
        // Fallback: if editing existing with comma-separated IDs
        const categoryIds = String(
          markInfluencer?.data?.InfluencerCategoryID
        ).split(",");
        const selectedCategories = markInfluencerList
          ?.filter((d) => categoryIds.includes(String(d?.categoryID)))
          .map((d) => d?.category);
        setSelectedInfluencers(selectedCategories || []);
      }
    } else {
      // For single select, use existing logic
      let initialObj = markInfluencerList?.filter(
        (d) => d?.categoryID === markInfluencer?.data?.InfluencerCategoryID
      );
      setSelectedInfluencer({
        category: initialObj?.[0]?.category,
        categoryID: initialObj?.[0]?.categoryID,
      });
    }
  }, [markInfluencerList, isMultipleSelect]);

  const handleMarkInfluencerCancel = () => {
    setMarkInfluencer({
      modalShow: false,
      data: null,
    });
  };

  const handleMarkInfluencer = () => {
    // dispatch(setMarkInfluencersFlag(true));

    let postData = markInfluencer?.data;
    // console.log("Add MarkInfluencer", postData);

    // Handle multiple vs single selection
    let obj;

    if (isMultipleSelect) {
      // For multiple selection, create InfluencerCategories array
      const selectedData = markInfluencerList?.filter((d) =>
        selectedInfluencers.includes(d?.category)
      );
      const influencerCategories = selectedData?.map((d) => ({
        influencerCategoryID: d?.categoryID,
        influencerCategoryName: d?.category,
      }));

      obj = {
        AuthorSocialID: Number(postData?.AuthorAuthorID),
        BrandID: postData?.PostBrandID,
        BrandName: postData?.BrandName,
        ChannelType: enumConfig?.socialmediaplatforms[postData?.ChannelGroupID],
        InfluencerCategories: influencerCategories || [],
        ScreenName: postData?.AuthorScreenName,
        AuthorName: postData?.AuthorName,
        TagId: postData?.TagID
          ? postData?.TagID
          : postData?.TagId
          ? postData?.TagId
          : postData?.tagid,
        InfluencerCategoryID: 0,
        InfluencerCategoryName: null,
      };
    } else {
      // For single selection, use existing structure
      obj = {
        AuthorSocialID: postData?.AuthorAuthorID,
        BrandID: postData?.PostBrandID,
        BrandName: postData?.BrandName,
        ChannelType: enumConfig?.SocialMediaPlatforms[postData?.ChannelGroupID],
        InfluencerCategoryID: selectedInfluencer?.categoryID,
        InfluencerCategoryName: selectedInfluencer?.category,
        ScreenName: postData?.AuthorScreenName,
        AuthorName: postData?.AuthorName,
        TagId: postData?.TagID
          ? postData?.TagID
          : postData?.TagId
          ? postData?.TagId
          : postData?.tagid,
      };
    }

    if (tabClick?.tabName === "influencers") {
      delete influencers_object.deepdive_on.order_by;
      delete influencers_object.filter_by_data;
      influencers_object.filter_by = null;
    }
    let mention_obj = {
      screen: screen,
      shareBrands: shareBrands,
      shareTemplateData: shareTemplateData,
      mentions_object: mentions_object,
      authParams: authParams,
      markInfluencerFlag: true,
      selectedTabName: tabClick?.tabName,
      influencers_object: influencers_object,
    };

    dispatch(InsertMarkInfluencerPost(obj, mention_obj));

    setMarkInfluencer({
      modalShow: false,
      data: null,
    });

    if (tabClick?.tabName === "mentions") {
      dispatch(setMentionPageInnerTabs(true));
    } else if (tabClick?.tabName === "influencers") {
      dispatch(setDeepDiveInfoLoader(true));
    }
  };

  const handleRemoveInfluencer = () => {
    // dispatch(setMarkInfluencersFlag(true));

    let postData = markInfluencer?.data;
    // console.log("Remove Mark Influencer", postData);

    // Handle multiple vs single selection for remove
    let obj;

    if (isMultipleSelect) {
      // For multiple selection, create InfluencerCategories array
      const selectedData = markInfluencerList?.filter((d) =>
        selectedInfluencers.includes(d?.category)
      );
      const influencerCategories = selectedData?.map((d) => ({
        influencerCategoryID: d?.categoryID,
        influencerCategoryName: d?.category,
      }));

      obj = {
        AuthorSocialID: Number(postData?.AuthorAuthorID),
        BrandID: postData?.PostBrandID,
        BrandName: postData?.BrandName,
        ChannelType: enumConfig?.socialmediaplatforms[postData?.ChannelGroupID],
        InfluencerCategories: influencerCategories || [],
        IsInactive: 1,
        ScreenName: postData?.AuthorScreenName,
        AuthorName: postData?.AuthorName,
        TagId: postData?.TagID
          ? postData?.TagID
          : postData?.TagId
          ? postData?.TagId
          : postData?.tagid,
        InfluencerCategoryID: 0,
        InfluencerCategoryName: null,
      };
    } else {
      // For single selection, use existing structure
      obj = {
        AuthorSocialID: postData?.AuthorAuthorID,
        BrandID: postData?.PostBrandID,
        BrandName: postData?.BrandName,
        ChannelType: enumConfig?.SocialMediaPlatforms[postData?.ChannelGroupID],
        InfluencerCategoryID: selectedInfluencer?.categoryID,
        InfluencerCategoryName: selectedInfluencer?.category,
        IsInactive: 1,
        ScreenName: postData?.AuthorScreenName,
        AuthorName: postData?.AuthorName,
        TagId: postData?.TagID
          ? postData?.TagID
          : postData?.TagId
          ? postData?.TagId
          : postData?.tagid,
      };
    }

    if (tabClick?.tabName === "influencers") {
      delete influencers_object.deepdive_on.order_by;
      delete influencers_object.filter_by_data;
      influencers_object.filter_by = null;
    }
    let mention_obj = {
      screen: screen,
      shareBrands: shareBrands,
      shareTemplateData: shareTemplateData,
      mentions_object: mentions_object,
      authParams: authParams,
      markInfluencerFlag: true,
      selectedTabName: tabClick?.tabName,
      influencers_object: influencers_object,
    };
    dispatch(removeMarkInfluencerPost(obj, mention_obj));

    setMarkInfluencer({
      modalShow: false,
      data: null,
    });

    if (tabClick?.tabName === "mentions") {
      dispatch(setMentionPageInnerTabs(true));
    } else if (tabClick?.tabName === "influencers") {
      dispatch(setDeepDiveInfoLoader(true));
    }
  };

  function onSearch(val) {
    // console.log("onSearch value", val);
  }

  const handleChange = (selectedCategory) => {
    if (isMultipleSelect) {
      // For multiple select, selectedCategory is an array
      // Handle "Select All" option
      if (selectedCategory.includes("SELECT_ALL")) {
        // If "Select All" is clicked
        if (selectedInfluencers.length === markInfluencerList?.length) {
          // If all are already selected, deselect all
          setSelectedInfluencers([]);
        } else {
          // Select all categories
          const allCategories =
            markInfluencerList?.map((d) => d?.category) || [];
          setSelectedInfluencers(allCategories);
        }
      } else {
        // Normal selection
        setSelectedInfluencers(selectedCategory);
      }
    } else {
      // For single select, selectedCategory is a string
      let filteredObj = markInfluencerList?.filter(
        (d) => d?.category === selectedCategory
      );

      setSelectedInfluencer({
        category: filteredObj?.[0]?.category,
        categoryID: filteredObj?.[0]?.categoryID,
      });
    }
  };

  return (
    <>
      <Modal
        title="Mark Influencer"
        open={isOpen}
        onCancel={handleMarkInfluencerCancel}
        className="Mark_Influencer_container"
        maskClosable={false}
        onOk={handleMarkInfluencer}
        footer={null}
        mask={true}
        centered
      >
        <div className="Campaign__body">
          <div className="mark_influencer_dropdown">
            <Select
              mode={isMultipleSelect ? "multiple" : undefined}
              showArrow={true}
              showSearch
              onSearch={onSearch}
              className="sharable-dropdown border-color"
              style={{
                width: "100%",
              }}
              placeholder={
                isMultipleSelect
                  ? "Select Multiple Influencer Categories"
                  : "Select Influencer Category"
              }
              value={
                isMultipleSelect
                  ? selectedInfluencers
                  : selectedInfluencer?.category
              }
              defaultValue={
                isMultipleSelect
                  ? selectedInfluencers
                  : selectedInfluencer?.category
              }
              onChange={handleChange}
              listItemHeight={10}
              listHeight={160}
              filterOption={true}
              dropdownClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
              maxTagCount={isMultipleSelect ? 2 : undefined}
              maxTagTextLength={isMultipleSelect ? 10 : undefined}
            >
              {isMultipleSelect && (
                <Option key="select-all" value="SELECT_ALL">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div
                        className="font-weight500"
                        style={{ fontWeight: "bold" }}
                      >
                        {selectedInfluencers.length ===
                        markInfluencerList?.length
                          ? "Deselect All"
                          : "Select All"}
                      </div>
                    </div>
                  </div>
                </Option>
              )}
              {markInfluencerList &&
                markInfluencerList?.map((d, i) => (
                  <Option key={i} value={d?.category}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <div
                          className="font-weight500"
                          // style={{ color: "#fff" }}
                        >
                          {d?.category}
                        </div>
                      </div>
                    </div>
                  </Option>
                ))}
            </Select>
          </div>
        </div>
        <div className="Campaign__footer d-flex justify-content-end">
          {(markInfluencer?.data?.InfluencerCategoryID &&
            markInfluencer?.data?.InfluencerCategoryID !== "" &&
            markInfluencer?.data?.InfluencerCategoryID !== "NA") ||
          (markInfluencer?.data?.InfluencerCategories &&
            markInfluencer?.data?.InfluencerCategories.length > 0) ? (
            <>
              <Button
                type="button"
                style={{ width: "15rem", textTransform: "none", color: "red" }}
                className="mr-15 "
                onClick={handleRemoveInfluencer}
              >
                Remove Influencer
              </Button>
              <Button
                type="button"
                disabled={
                  isMultipleSelect
                    ? selectedInfluencers.length === 0 ||
                      (() => {
                        // Check if current selection matches existing data
                        const currentSelection = markInfluencerList
                          ?.filter((d) =>
                            selectedInfluencers.includes(d?.category)
                          )
                          .map((d) => d?.categoryID)
                          .sort()
                          .join(",");

                        // Check against InfluencerCategories array if present
                        if (markInfluencer?.data?.InfluencerCategories) {
                          const existingSelection =
                            markInfluencer?.data?.InfluencerCategories.map(
                              (cat) => cat?.influencerCategoryID
                            )
                              .sort()
                              .join(",");
                          return currentSelection === existingSelection;
                        }

                        // Fallback to checking InfluencerCategoryID
                        if (markInfluencer?.data?.InfluencerCategoryID) {
                          return (
                            currentSelection ===
                            markInfluencer?.data?.InfluencerCategoryID.split(
                              ","
                            )
                              .sort()
                              .join(",")
                          );
                        }

                        return false;
                      })()
                    : markInfluencer?.data?.InfluencerCategoryID ===
                      selectedInfluencer?.categoryID
                }
                style={{ width: "15rem", textTransform: "none" }}
                className="ant-btn ant-btn-primary ant-btn-primary_blue mr-15 "
                onClick={handleMarkInfluencer}
              >
                Update Influencer
              </Button>
            </>
          ) : (
            ""
          )}
          {(!markInfluencer?.data?.InfluencerCategoryID ||
            markInfluencer?.data?.InfluencerCategoryID === "" ||
            markInfluencer?.data?.InfluencerCategoryID === "NA") &&
          (!markInfluencer?.data?.InfluencerCategories ||
            markInfluencer?.data?.InfluencerCategories.length === 0) ? (
            <Button
              type="button"
              disabled={
                isMultipleSelect
                  ? selectedInfluencers.length === 0
                  : !selectedInfluencer?.categoryID
              }
              style={{ width: "15rem", textTransform: "none" }}
              className="ant-btn ant-btn-primary ant-btn-primary_blue mr-15 "
              onClick={handleMarkInfluencer}
            >
              Mark Influencer
            </Button>
          ) : (
            ""
          )}
        </div>
      </Modal>
    </>
  );
};

export default React.memo(MarkInfluencerPost, isEqual);
